import React from 'react';
import { BanIcon, LockIcon, TimerIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const badges = [{
  icon: LockIcon,
  label: 'Video seguro'
}, {
  icon: BanIcon,
  label: 'Sin anuncios'
}, {
  icon: TimerIcon,
  label: 'Menos de 05 min'
}];
export function VideoSection() {
  return <section id="video" className="w-full scroll-mt-16 bg-cream py-16" data-id="element-180" data-mp="1irv6l1ok2lv2">
      <div className="mx-auto max-w-[800px] px-5 text-center sm:px-6" data-id="element-181" data-mp="1ws5zea9feaiv">
        <Reveal data-id="element-182" data-mp="1wqcrysqznm9t">
          <span className="inline-flex rounded-full border border-gold px-3.5 py-1 text-[12px] font-semibold text-forest" data-id="element-183" data-mp="1wpt6x361khrk">
            Mira esto antes de seguir
          </span>

          <h2 className="mx-auto mt-5 max-w-2xl text-[26px] font-bold leading-tight tracking-tight text-forest sm:text-[32px]" data-id="element-184" data-mp="26h7d1tsi0fto">
            Descubre Exactamente Cómo Funciona el Método de Vaciado Biológico
          </h2>

          <p className="mx-auto mt-3 max-w-xl text-base font-normal leading-relaxed text-warmgray" data-id="element-185" data-mp="2fgawiyvkux8p">
            Este video de pocos minutos explica lo que los médicos convencionales nunca te contarán
            sobre los parásitos modernos.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-186" data-mp="yvsc1natsgz6">
          <div className="mt-8 overflow-hidden rounded-2xl border-2 border-gold shadow-2xl" data-id="element-187" data-mp="13ud4v1nqzydl">
            <div className="aspect-video w-full bg-forest-deep" data-id="element-188" data-mp="13wpve37knh29">
              <iframe src="https://player.cloudinary.com/embed/?cloud_name=lkfj1jku&public_id=VSL_Baciado" title="Video: cómo funciona el Método de Vaciado Biológico" className="h-full w-full" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowFullScreen frameBorder="0" data-id="element-189" data-mp="18v16eh9lrxm2" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} data-id="element-190" data-mp="1rjxyqflfwg1n">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-191" data-mp="1rk7j9nnptuzy">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[13px] font-semibold text-warmgray" data-id="element-192" data-mp="21i54s3e6xdov">
                <Icon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-193" data-mp="1btq7g5l5uwgh" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}